jQuery( document ).ready(function($) { 
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '992',
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });
});

$(function () {
  $(".slimmenu ul > li.has-submenu").on('mouseenter mouseleave', function (e) {
    var elm = $('>ul', this);
    var off = elm.offset();
    var l = off.left;
    var w = elm.width();
    var docW = $("body").width();

    var isEntirelyVisible = (l + w <= docW);

    if (!isEntirelyVisible) {
        $(this).children('ul').addClass('edge');
    } else {
        $(this).children('ul').removeClass('edge');
    }
  });
});